import { Box } from '@qbe/ads-core';
import React from 'react';

import LinkButton from '~/components-ds/LinkButton';
import { useAppContent } from '~/hooks';
import { Cover } from '~/types/cover';

export const RemoveCoverButton: React.FC<{
  remove: (covers: Cover[]) => void;
  coversToRemove: Cover[];
}> = ({ remove, coversToRemove }) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.review.buttons',
  });
  return (
    <Box marginLeft="auto">
      <LinkButton
        label={getTextContent('removeCover')}
        dataTrack={`Click here to remove - ${coversToRemove.join(' | ')}`}
        onClick={() => remove(coversToRemove)}
      />
    </Box>
  );
};
